import React, {FC} from 'react';
import Filters from './filters';
import {FilterMap} from 'features/table/slice/types';
import {Button, CardBody, Col, Row} from 'reactstrap';
import {useLocalStorage} from 'usehooks-ts';
import {TagsRow} from './tags-row';
import {useTranslation} from 'react-i18next';

interface FilterProps {
  filters: FilterMap;
  onChangeFilters: (key: string, value: any) => void;
  onClearFilters?: () => void;
}

const CreditsControls: FC<FilterProps> = props => {
  const {t} = useTranslation();

  const {filters, onChangeFilters, onClearFilters} = props;

  return (
    <Row>
      <Col>
        <CardBody>
          <TagsRow />

          <Filters
            filters={filters}
            onChangeFilters={onChangeFilters}
            onClearFilters={onClearFilters}
          />
        </CardBody>
      </Col>
    </Row>
  );
};

export default CreditsControls;
